export default "__VITE_ASSET__DdaNGo95__"